import React, { useEffect, useState } from "react";
import UserListPopup from "./UserListPopup";
import { formatDate } from "src/utils/CommonUtils";
import DateRangePicker from "../DateRangePicker";
import OnlyDateRangePicker from "../OnlyDateRangePicker";

const MessageActionAndFilter = ({
  messageActionFlag,
  messageFilterFlag,
  isMessageActionOpen,
  setIsMessageActionOpen,
  isUserPopupOpen,
  setIsUserPopupOpen,
  SearchActionUser,
  deleteMultipleMessages,
  setDeleteMessageFlagGroup,
  setSearchMessageString,
  setSearchMessageType,
  searchMessage,
  dateRange,
  setDateRange,
  resetAndToggleModal,
  setSelectMessages,
  setMessageActionFlag,
  setMediaToForward
}) => {
  const [activeButton, setActiveButton] = useState("text");

  const handleDateRangeChange = (start, end) => {
    setDateRange({ start, end });
  };

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  const getButtonStyle = (buttonName) => {
    return activeButton === buttonName
      ? { background: "#fff", boxShadow: "0 0 2px rgb(13 110 253)" }
      : { background: "#CBE9FB", border: "none" };
  };

  return (
    <>
      {}
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n         .bclosbtn {\n            background: #1a1a1a;\n            width: 20px;\n            height: 20px;\n            padding: 0;\n            border-radius: 20px;\n            font-size: 10px;\n            color: #fff;\n            outline: none;\n            border: none;\n         }\n\n         .selecreplydv {\n            display: flex;\n         }\n\n         .usserchbg {\n            background: #fff;\n            border-radius: 50px;\n            padding: 0 7px;\n         }\n\n         .usserchbg .bg-body {\n            max-height: 200px;\n            overflow: hidden;\n            overflow-y: auto;\n         }\n\n         .mxw-256px {\n            min-width: 256px;\n            max-width: 256px;\n         }\n\n         .usserch .imggrp1 {\n            width: 25px;\n            height: 25px;\n         }\n\n         .nm1 div,\n         .nm1 small {\n            max-width: 200px;\n            display: -webkit-box !important;\n            -webkit-line-clamp: 1;\n            -webkit-box-orient: vertical;\n            width: 100%;\n            overflow: hidden;\n         }\n\n         .usserchbg button.btnu {\n            border: 1px solid #e6e6e6;\n            background: #fff;\n            font-size: 22px;\n            padding: 0px 5px;\n            line-height: 20px;\n         }\n\n         .usserchbg .btnup {\n            border-radius: 10px 0 0 10px;\n         }\n\n         .usserchbg .btndown {\n            border-radius: 0px 10px 10px 0px;\n         }\n\n         .usserchbg button.btnu:hover {\n            color: #1C9DEA;\n         }\n\n\n         .usserchbg .magnify {\n            height: 28px;\n            margin-top: 4px;\n            margin-bottom: 4px;\n         }\n\n         .alunsbtn {\n            min-width: 117px;\n         }\n\n         .btnIconsSearch {\n            border: none;\n            outline: none;\n            ;\n            background: #CBE9FB;\n            width: 25px;\n            height: 25px;\n            border-radius: 20px;\n  display: flex;\n   justify-content: center;\n      align-items: center;\n     }\n\n         .btnIconsSearch:hover {\n            background: #fff;\n         }\n\n         .mxwxctm {\n            max-width: max-content;\n            width: auto;\n         }\n\n         .PinnedMsg {\n            position: sticky;\n            top: 10px;\n            right: 10px;\n            width: 142px;\n            height: 100px;\n            background: #fff;\n            margin-left: auto;\n            border: 1px solid #dee2e6;\n            z-index: 9;\n         }\n\n         .PinnedMsg button.btnu {\n            border: 1px solid #e6e6e6;\n            background: #fff;\n            font-size: 22px;\n            padding: 0px 5px;\n            line-height: 20px;\n         }\n\n         .PinnedMsg .btnup {\n            border-radius: 10px 0 0 10px;\n         }\n\n         .PinnedMsg .btndown {\n            border-radius: 0px 10px 10px 0px;\n         }\n\n         .PinnedMsg button.btnu:hover {\n            color: #1C9DEA;\n         }\n\n         .PinnedMsg1 {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            flex-direction: column;\n            height: 100%;\n            grid-gap: 0.5rem;\n         }\n\n         .PinnedMsg .bclosbtn {\n            position: absolute;\n            right: 3px;\n            top: 3px;\n         }\n\n         .emRct {\n            max-width: 200px;\n            display: flex;\n            align-items: center;\n            border-radius: 50px;\n            background: #fff;\n            padding: 0px 4px;\n            transform: translateY(-10px);\n         }\n\n         .emRct img {\n            max-width: 24px;\n            width: 100%;\n         }\n\n         .emRct .emji {\n            border: none;\n            background: #fff;\n            padding: 4px;\n            border-radius: 20px;\n         }\n\n         .emRct .emji:last-child {\n            background: #e6e6e6;\n            min-width: 24px;\n            max-width: 24px;\n            height: 24px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            margin-left: 4px;\n         }\n\n         .bgreplds {\n            padding: 10px;\n            background: #c1dff1;\n            border-radius: 10px;\n            border: 1px solid #e6e6e6;\n         }\n\n         .bgretext {\n            padding: 10px 15px 15px 15px;\n            color: #223645;\n            font-size: 14px;\n            line-height: 1.5;\n            text-align: left;\n            font-weight: 400;\n         }\n\n         .bgreplds p {\n            border-radius: 0 !important;\n         }\n\n         .emojiSndbg {\n            display: inline-block;\n         }\n\n         .emojiSndbg .emojiSnd {\n            display: inline-block;\n         }\n\n         .S-Emoji img {\n            width: 80px\n         }\n      ",
        }}
      />
      {messageActionFlag && (
        <div
          className="pt-3  align-items-center justify-content-between gap-1 selecreplydv"
          
        >
          <div className="d-flex align-items-center gap-1">
            {}
            <button
              className="color1a font-14 fw-500 rounded-5 py-1 px-3 d-flex align-items-center gap-2"
              onClick={() => {
                if (!isUserPopupOpen) {
                  SearchActionUser();
                }
                setIsUserPopupOpen(!isUserPopupOpen);
              }}
            >
              <i className="mdi mdi-share"></i> Forward
            </button>
            <button
              className="color1a font-14 fw-500 rounded-5 py-1 px-3 d-flex align-items-center gap-2"
              onClick={() => {
                setDeleteMessageFlagGroup(true)
              }}
            >
              {}
              <i className="mdi mdi-delete-variant" /> Delete{" "}
            </button>
            {}
            {}
          </div>
          <button
            className="bclosbtn"
            onClick={() => {
      setMessageActionFlag(false);
      setSelectMessages([]);
      setMediaToForward(null);
            }}
          >
            <i className="mdi mdi-close m-0" />
          </button>
        </div>
      )}

      {}
      {messageFilterFlag && (
        <div
          className="usserchmnd mt-3"
          id="searchDpDown"
          
        >
          <div className="usserchbg">
            <div className="d-flex align-items-center mb-0">
              {}

              <span className="d-flex align-items-center px-2 font-22 colorb border-0 magnify">
                <i className="mdi mdi-magnify" />
              </span>
              <input
                type="text"
                className="form-control py-0"
                placeholder="Search "
                aria-label="Text input with dropdown button"
                onChange={(e) => {
                  setSearchMessageString(e.target.value);
                  localStorage.setItem("searchMessageString", e.target.value)
                  // searchMessage(e.target.value);
                }}
              />
              {}
            </div>
          </div>
          <div className="d-flex gap-1 align-items-center justify-content-between pt-2">
            <div className="d-flex gap-1 align-items-center">
              <button
                className="btnIconsSearch btnI1"
                onClick={() => {
                  setSearchMessageType("text");
                  handleButtonClick("text");
                }}
                style={getButtonStyle("text")}
              >
                <img
                  src="/assets/images/search/t-icon.svg"
                  className="img-fluid"
                  alt=""
                  loading="lazy"

                />
              </button>
              <button
                className="btnIconsSearch btnI2"
                onClick={() => {
                  setSearchMessageType("image");
                  handleButtonClick("image");
                }}
                style={getButtonStyle("image")}
              >
                <img
                  src="/assets/images/search/img-icon.svg"
                  className="img-fluid"
                  alt=""
                />
              </button>
              <button
                className="btnIconsSearch btnI3"
                onClick={() => {
                  setSearchMessageType("document");
                  handleButtonClick("document");
                }}
                style={getButtonStyle("document")}
              >
                <img
                  src="/assets/images/search/txx-icon.svg"
                  className="img-fluid"
                  alt=""
                />
              </button>
              <button
                className="btnIconsSearch btnI4"
                onClick={() => {
                  setSearchMessageType("video");
                  handleButtonClick("video");
                }}
                style={getButtonStyle("video")}
              >
                <img
                  src="/assets/images/search/v-icon.svg"
                  className="img-fluid"
                  alt=""
                />
              </button>
              <button
                className="btnIconsSearch btnI5"
                onClick={() => {
                  setSearchMessageType("audio");
                  handleButtonClick("audio");
                }}
                style={getButtonStyle("audio")}
              >
                <img
                  src="/assets/images/search/ad-icon.svg"
                  className="img-fluid"
                  alt=""
                />
              </button>
              <button
                className="btnIconsSearch btnI6"
                onClick={() => {
                  setSearchMessageType("link");
                  handleButtonClick("link");
                }}
                style={getButtonStyle("link")}
              >
                <img
                  src="/assets/images/search/i-icon.svg"
                  className="img-fluid"
                  alt=""
                />
              </button>
              <button
                className="btnIconsSearch btnI7"
                onClick={() => {
                  setSearchMessageType("code");
                  handleButtonClick("code");
                }}
                style={getButtonStyle("code")}
              >
                <img
                  src="/assets/images/search/c-icon.svg"
                  className="img-fluid"
                  alt=""
                />
              </button>
              <button
                className="btnIconsSearch btnI8"
                onClick={() => {
                  setSearchMessageType("contact");
                  handleButtonClick("contact");
                }}
                style={getButtonStyle("contact")}
              >
                <img
                  src="/assets/images/search/b-icon.svg"
                  className="img-fluid"
                  alt=""
                />
              </button>
              <button
                className="btnIconsSearch btnI9"
                onClick={() => {
                  setSearchMessageType("location");
                  handleButtonClick("location");
                }}
                style={getButtonStyle("location")}
              >
                <img
                  src="/assets/images/search/l-icon.svg"
                  className="img-fluid"
                  alt=""
                />
              </button>
            </div>
            <DateRangePicker onDateRangeChange={handleDateRangeChange} />
          </div>
        </div>
      )}
    </>
  );
};

export default MessageActionAndFilter;
